import React, { useEffect, useState } from 'react'
import './style.css'

interface Props {
  open: boolean
  onClose: () => void
  leader: {
    name: string
    position: string
    enPosition: string
    intro: string
    profile: string
  }
}

const ANIMATION_DURATION = 250 // ms

const ManagershipDialog: React.FC<Props> = ({ open, onClose, leader }) => {
  const [visible, setVisible] = useState(open)

  useEffect(() => {
    if (open) {
      setVisible(true)
    } else {
      const timer = setTimeout(() => setVisible(false), ANIMATION_DURATION)
      return () => clearTimeout(timer)
    }
  }, [open])

  if (!visible) return null

  return (
    <div className={`managershipDialog-backdrop${open ? ' show' : ' hide'}`}>
      <div className={`managershipDialog${open ? ' show' : ' hide'}`}>
        <img className='managershipDialog-profile' src={leader.profile} alt={leader.name} />
        <button className='managershipDialog-close' onClick={onClose} aria-label='close' />
        <div className='managershipDialog-content'>
          <div className='managershipDialog-title'>
            <span>{leader.name}</span>
            <span>
              {leader.position}
              {leader.enPosition}
            </span>
          </div>
          <div className='managershipDialog-intro'>{leader.intro}</div>
        </div>
      </div>
    </div>
  )
}

export default ManagershipDialog
